import { defineComponent as w, computed as m, createElementBlock as s, openBlock as i, createElementVNode as o, withDirectives as B, normalizeClass as F, createCommentVNode as l, createBlock as d, Fragment as P, createVNode as u, unref as n, normalizeStyle as g, mergeProps as $, toDisplayString as L, renderSlot as y, vShow as O } from "vue";
import { ScalarIconCaretRight as h, ScalarIconArrowUpRight as A } from "@scalar/icons";
import { GuideIcon as f } from "@scalar-org/guide-icons";
const D = { class: "sidebar-group-item" }, E = {
  key: 0,
  class: "sidebar-heading-chevron"
}, I = ["aria-controls", "aria-expanded"], N = { class: "sidebar-heading-link-title" }, T = {
  key: 2,
  class: "action-menu"
}, V = ["id"], U = /* @__PURE__ */ w({
  __name: "SidebarElement",
  props: {
    item: {},
    isActive: { type: Boolean },
    hasChildren: { type: Boolean },
    open: { type: Boolean },
    resolvePage: { type: Function }
  },
  emits: ["select", "toggleOpen"],
  setup(k, { emit: b }) {
    const t = k, a = b, v = m(() => {
      const e = t.item;
      return e.type === "Link" ? {
        href: e.link,
        rel: "noopener noreferrer",
        target: "_blank"
      } : e.type === "Page" ? {
        href: t.resolvePage?.(e.uid) || "#"
      } : {};
    }), c = m(() => t.hasChildren || t.item.type === "Folder");
    function C() {
      if (t.item.type !== "Link") {
        if (t.item.type === "Folder") {
          a("toggleOpen");
          return;
        }
        a("select");
      }
    }
    function S() {
      t.item.type !== "Folder" && a("toggleOpen");
    }
    return (e, r) => (i(), s("li", D, [
      o("div", {
        class: F(["sidebar-heading", {
          active_page: e.isActive,
          "sidebar-group-item__folder": e.item.type === "Folder"
          /* Folder */
        }]),
        onClick: C
      }, [
        c.value ? (i(), s("p", E, [
          o("button", {
            "aria-controls": `${e.item.uid}-content`,
            "aria-expanded": e.open,
            class: "toggle-nested-icon",
            type: "button",
            onClick: S
          }, [
            r[1] || (r[1] = o("span", { class: "sr-only" }, "Toggle group", -1)),
            e.item?.icon?.src ? (i(), s(P, { key: 0 }, [
              u(n(f), {
                class: "sidebar-icon",
                src: e.item.icon.src
              }, null, 8, ["src"]),
              u(n(h), {
                class: "sidebar-icon-caret hidden",
                style: g({
                  transform: e.open ? "rotate(90deg)" : "rotate(0deg)"
                }),
                weight: "bold"
              }, null, 8, ["style"])
            ], 64)) : (i(), d(n(h), {
              key: 1,
              style: g({
                transform: e.open ? "rotate(90deg)" : "rotate(0deg)"
              }),
              weight: "bold"
            }, null, 8, ["style"]))
          ], 8, I)
        ])) : l("", !0),
        o("a", $({ class: "sidebar-heading-link flex-1" }, v.value, {
          onClick: r[0] || (r[0] = (p) => e.item.type === "Link" ? p.stopPropagation() : p.preventDefault())
        }), [
          e.item?.icon?.src && !c.value ? (i(), d(n(f), {
            key: 0,
            class: "sidebar-icon",
            src: e.item.icon.src
          }, null, 8, ["src"])) : l("", !0),
          o("p", N, L(e.item.sidebarTitle?.trim() || e.item.title.trim() || e.item.type), 1)
        ], 16),
        e.item?.type === "Link" ? (i(), d(n(A), {
          key: 1,
          class: "link-icon",
          weight: "bold"
        })) : l("", !0),
        e.$slots["action-menu"] ? (i(), s("div", T, [
          y(e.$slots, "action-menu", {}, void 0, !0)
        ])) : l("", !0)
      ], 2),
      B(o("div", {
        id: `${e.item.uid}-content`,
        class: "contents"
      }, [
        y(e.$slots, "default", {}, void 0, !0)
      ], 8, V), [
        [O, e.open]
      ])
    ]));
  }
});
export {
  U as default
};
